import BaseService from './BaseService';
import apiClient from '../plugins/axios';

class AgentConfigService extends BaseService {
  constructor() {
    super('agent/config');
  }

  async getAllAgentConfigs() {
    try {
      const response = await apiClient.get('/agent/config');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getAgentConfigByExternalId(externalId) {
    try {
      const response = await apiClient.get(`/agent/config/${encodeURIComponent(externalId)}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createAgentConfig(body) {
    try {
      const response = await apiClient.post('/agent/config', body);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateAgentConfigByExternalId(externalId, body) {
    try {
      const response = await apiClient.put(`/agent/config/${encodeURIComponent(externalId)}`, body);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteAgentConfigByExternalId(externalId) {
    try {
      const response = await apiClient.delete(`/agent/config/${encodeURIComponent(externalId)}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new AgentConfigService();
